export const SITE_URL = (import.meta as any).env?.VITE_SITE_URL || 'https://natuvia.com';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/og/default.jpg`;
export const LOGO_SVG_URL = `${SITE_URL}/brand/logo.svg`;

export function toAbsoluteUrl(urlOrPath: string | undefined | null): string {
  if (!urlOrPath) return DEFAULT_OG_IMAGE;
  if (/^https?:\/\//i.test(urlOrPath)) return urlOrPath;
  const path = urlOrPath.startsWith('/') ? urlOrPath : `/${urlOrPath}`;
  return `${SITE_URL}${path}`;
}

export function getOgImageWithFallback(image: string | undefined | null): string {
  if (!image) return DEFAULT_OG_IMAGE;
  return toAbsoluteUrl(image);
}

export interface AlternateLink {
  lang: string;
  href: string;
}

export function getAlternates(pathWithoutLang: string): AlternateLink[] {
  const cleanPath = pathWithoutLang.startsWith('/') ? pathWithoutLang : `/${pathWithoutLang}`;
  return [
    { lang: 'en', href: `${SITE_URL}/en${cleanPath}` },
    { lang: 'zh-HK', href: `${SITE_URL}/zh-hk${cleanPath}` },
    { lang: 'x-default', href: `${SITE_URL}/en${cleanPath}` },
  ];
}

export function getAlternatesForPath(fullPath: string): AlternateLink[] {
  const pathWithoutLang = fullPath.replace(/^\/(en|zh-hk)\/?/, '/').replace(/^\/+/, '/');
  const cleanPath = pathWithoutLang === '/' ? '' : pathWithoutLang;
  return [
    { lang: 'en', href: `${SITE_URL}/en${cleanPath}` },
    { lang: 'zh-HK', href: `${SITE_URL}/zh-hk${cleanPath}` },
    { lang: 'x-default', href: `${SITE_URL}/en${cleanPath}` },
  ];
}
